import React from 'react';

const Loader = () => (
  <div className="cube_wrapper">
    <div className="cube_loader_colum">
      <div className="cube_loader_inner">
        <div className="cube_folding">
          <div className="leaf leaf1"></div>
          <div className="leaf leaf2"></div>
          <div className="leaf leaf3"></div>
          <div className="leaf leaf4"></div>
        </div>
        <div className="loading">Loading ...</div>
      </div>
    </div>
  </div>
);

export default Loader;
